import { useTranslation, Trans } from 'react-i18next';
import styles from './index.module.less';
import chromeLogo from '@/assets/images/chrome.svg';
import g2Logo from '@/assets/images/g2.png';
import itreviewLogo from '@/assets/images/itreview.png';

const PLATFORMS = [
  {
    key: 'chrome',
    reward: 30,
    logo: chromeLogo,
    url: 'https://chromewebstore.google.com/detail/felo-subtitles-chatgpt-li/ponokiofkijoolhebggofhhibnafebna',
  },
  {
    key: 'g2',
    reward: 60,
    logo: g2Logo,
    url: 'https://www.g2.com/products/felo-subtitles/reviews',
  },
  {
    key: 'itreview',
    reward: 60,
    logo: itreviewLogo,
    url: 'https://www.itreview.jp/products/felo-meet/reviews',
  },
];

function ReviewRewards() {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>{t('reviewRewards.subtitle')}</h1>
        <p className={styles.description}>{t('reviewRewards.description')}</p>
      </div>

      <div className={styles.platformGrid}>
        {PLATFORMS.map((platform) => (
          <div key={platform.key} className={styles.platformCard}>
            <div className={styles.platformHeader}>
              <div className={styles.platformLogo}>
                <img src={platform.logo} alt={t(`reviewRewards.${platform.key}.name`)} />
              </div>
              <div className={styles.platformName}>
                {t(`reviewRewards.${platform.key}.name`)}
              </div>
            </div>
            <div className={styles.rewardBadge}>
              {t('reviewRewards.rewardMinutes', { time: platform.reward })}
            </div>
            <div className={styles.platformDesc}>
              <Trans
                i18nKey={`reviewRewards.${platform.key}.desc`}
                components={{ bold: <strong /> }}
              />
            </div>
            <a
              className={styles.ctaButton}
              href={platform.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('reviewRewards.writeReview')}
            </a>
          </div>
        ))}
      </div>

      <div className={styles.section}>
        <div className={styles.sectionTitle}>
          📝 {t('reviewRewards.howToClaim')}
        </div>
        <ol className={styles.steps}>
          <li className={styles.stepItem}>{t('reviewRewards.step1')}</li>
          <li className={styles.stepItem}>{t('reviewRewards.step2')}</li>
          <li className={styles.stepItem}>
            <Trans
              i18nKey="reviewRewards.step3"
              components={{ email: <a href="mailto:support@sparticle.com" /> }}
            />
          </li>
          <li className={styles.stepItem}>{t('reviewRewards.step4')}</li>
        </ol>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionTitle}>
          {t('reviewRewards.rulesTitle')}
        </div>
        <ul className={styles.rules}>
          <li className={styles.ruleItem}>{t('reviewRewards.rule1')}</li>
          <li className={styles.ruleItem}>{t('reviewRewards.rule2')}</li>
          <li className={styles.ruleItem}>{t('reviewRewards.rule3')}</li>
          <li className={styles.ruleItem}>{t('reviewRewards.rule4')}</li>
          <li className={styles.ruleItem}>{t('reviewRewards.rule5')}</li>
        </ul>
      </div>
    </div>
  );
}

export default ReviewRewards;
